import { Component } from "react";
import { Card, Table, Tbody, Td, Th, Thead, Tr } from "ui-kit-ck-consultant";

import { getValue } from "../../../../utils/general";
import axiosConfig from "../../../../utils/axiosConfig";

export class CardHELVETIA extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
    };
  }

  componentDidMount() {
    this.getPerformance();
  }

  componentDidUpdate = (prevProps) => {
    if (
      JSON.stringify(prevProps.data) !== JSON.stringify(this.props.data) &&
      parseInt(this.props.data.company) === 38
    ) {
      this.getPerformance();
    }
  };

  getPerformance = () => {
    this.setState({ isLoad: true }, () => {
      axiosConfig("/company-performance/helvetia", {
        data: {
          dateStart: this.props.data.dateStart,
          dateEnd: this.props.data.dateEnd,
          network: this.props.data.network,
          group: this.props.data.group,
          region: this.props.data.region,
          agency: this.props.data.agency,
          user: this.props.data.user,
          company: this.props.data.company,
          darvaCode: this.props.data.darvaCode,
        },
      }).then((res) => {
        if (res.data.success) {
          this.setState({
            data: res.data.data,
            isLoad: false,
          });
        } else {
          this.setState({
            data: null,
            isLoad: false,
          });
        }
      });
    });
  };

  getTable = (title, data) => {
    return (
      <Card title={title} className={"mt-10"}>
        <Table>
          <Thead>
            <Tr>
              <Th></Th>
              <Th className="text-center">GLOBAL</Th>
              <Th colSpan={4} className="text-center">
                EAD
              </Th>
              <Th colSpan={4} className="text-center">
                VEHICULES REPARABLES
              </Th>
              <Th colSpan={2} className="text-center">
                VEHICULES IRREPARABLES
              </Th>
            </Tr>
            <Tr>
              <Th></Th>
              <Th>Volume total</Th>
              <Th>Volume</Th>
              <Th>Coût moyen HT</Th>
              <Th>Nb moyen heures de Main d'Œuvre (*1)</Th>
              <Th>Coût moyen HT Pièces</Th>
              <Th>Volume</Th>
              <Th>Coût moyen HT</Th>
              <Th>Nb moyen heures de Main d'Œuvre (*1)</Th>
              <Th>Coût moyen HT Pièces</Th>
              <Th>Volume</Th>
              <Th>VRADE HT moyenne</Th>
            </Tr>
          </Thead>
          <Tbody>
            <Tr>
              <Th>Résultats</Th>
              <Td>{getValue(data.count, 0)}</Td>
              <Td>{getValue(data.count_EAD, 0)}</Td>
              <Td>{getValue(data.averageCost_EAD)}</Td>
              <Td>{getValue(data.averageHour_EAD)}</Td>
              <Td>{getValue(data.averagePart_EAD)}</Td>
              <Td>{getValue(data.count_R, 0)}</Td>
              <Td>{getValue(data.averageCost_R)}</Td>
              <Td>{getValue(data.averageHour_R)}</Td>
              <Td>{getValue(data.averagePart_R)}</Td>
              <Td>{getValue(data.count_NR, 0)}</Td>
              <Td>{getValue(data.averageCost_NR)}</Td>
            </Tr>
            <Tr>
              <Th>Délais Moyen Dépôt Rapport</Th>
              <Td>{getValue(data.averageDelay)}</Td>
              <Td colSpan={4}>{getValue(data.averageDelay_EAD)}</Td>
              <Td colSpan={4}>{getValue(data.averageDelay_R)}</Td>
              <Td colSpan={2}>{getValue(data.averageDelay_NR)}</Td>
            </Tr>
            <Tr>
              <Th>Moyenne Honoraires HT</Th>
              <Td>{getValue(data.averageHonorary)}</Td>
              <Td colSpan={4}>{getValue(data.averageHonorary_EAD)}</Td>
              <Td colSpan={4}>{getValue(data.averageHonorary_R)}</Td>
              <Td colSpan={2}>{getValue(data.averageHonorary_NR)}</Td>
            </Tr>
          </Tbody>
        </Table>
      </Card>
    );
  };

  render() {
    if (!this.state.data) {
      return null;
    }

    return (
      <>
        {this.getTable(
          "VP CAMIONNETTES < 3,5t - DOSSIERS < À 15 000€ HT",
          this.state.data.VP_15000_INF
        )}
        {this.getTable(
          "VP CAMIONNETTES < 3,5t - ANALYSE DOSSIERS >= à 15 000€ HT",

          this.state.data.VP_15000_SUP
        )}
        {this.getTable(
          "P.L > 3,5t - DOSSIERS < À 15 000€ HT",
          this.state.data.PL_15000_INF
        )}
        {this.getTable(
          "P.L > 3,5t - ANALYSE DOSSIERS >= à 15 000€ HT",
          this.state.data.PL_15000_SUP
        )}
      </>
    );
  }
}

export default CardHELVETIA;
